import logo1 from "../../assets/img/historicEvents/LogoOnlysPPV/TTIT.png";

export const thisTuesdayInTexasDetail = {
  "this-tuesday-in-texas": {
    id: "this-tuesday-in-texas",
    title: "This Tuesday in Texas",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "this-tuesday-in-texas",
        items: [
          {
            id: "this-tuesday-in-texas-1",
            title: "This Tuesday in Texas",
            description: "1991",
            imgUrl: logo1,
          },
        ],
      },
    ],
  },
};
